import { Link } from '../lib/routing';

export default function AdminAccessDenied({ homePath }: { homePath: string }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4 p-4 text-center">
      <h1 className="text-xl font-semibold text-[var(--naia-text-primary)]">Accès réservé aux administrateurs</h1>
      <p className="text-[var(--naia-text-secondary)]">Cette page est réservée aux administrateurs.</p>
      <Link to={homePath} className="inline-flex items-center justify-center min-h-11 px-4 rounded-md bg-primary text-primary-foreground">
        Retour à mon accueil
      </Link>
    </div>
  );
}
